import { useAuth } from "@/stores";

export const fetchWrapper = {
  get: request("GET"),
  getWithBlob: requestBlob("GET"),
  postWithBlob: requestBlob("POST"),
  getPdf: requestPDF("GET"),
  postPdf: requestPDF("POST"),
  post: request("POST"),
  postFiles: requestpostFiles("POST"),
  put: request("PUT"),
  delete: request("DELETE"),
};

function request(method) {
  return (url, body) => {
    const requestOptions = {
      method,
      headers: authHeader(url),
    };
    if (body) {
      requestOptions.headers["Content-Type"] = "application/json";
      requestOptions.body = JSON.stringify(body);
    }
    return fetch(url, requestOptions).then(handleResponse);
  };
}

function requestpostFiles(method) {
  return (url, body) => {
    const requestOptions = {
      method,
      headers: authHeader(url),
    };
    if (body) {
      requestOptions.body = body;
    }
    return fetch(url, requestOptions).then(handleResponse);
  };
}

function requestBlob(method) {
  return (url, body) => {
    const requestOptions = {
      method,
      headers: authHeader(url),
    };
    if (body) {
      requestOptions.headers["Content-Type"] = "application/json";
      requestOptions.body = JSON.stringify(body);
    }
    return fetch(url, requestOptions).then(handleResponseBlob);
  };
}

function requestPDF(method) {
  return (url, body) => {
    const requestOptions = {
      method,
      headers: authHeader(url),
    };
    if (body) {
      requestOptions.headers["Content-Type"] = "application/json";
      requestOptions.body = JSON.stringify(body);
    }
    return fetch(url, requestOptions).then(handleResponsePDF);
  };
}

function authHeader(url) {
  const token = localStorage.getItem("token");
  const sessionToken = localStorage.getItem("session_token");
  const isApiUrl = url.startsWith(process.env.VUE_APP_ROOT_API);

  if (token && isApiUrl) {
    return {
      Authorization: `Bearer ${token}`,
      "X-Session-Token": sessionToken || "",
    };
  } else {
    return {};
  }
}

function handleResponseBlob(response) {
  if (response.ok) {
    response.blob().then(function (miBlob) {
      var fileURL = window.URL.createObjectURL(new Blob([miBlob]));
      var fileLink = document.createElement("a");
      fileLink.href = fileURL;
      fileLink.setAttribute(
        "download",
        new Date().toLocaleString().replace(/\D/g, "") + ".xlsx"
      );
      document.body.appendChild(fileLink);
      fileLink.click();
    });
  } else {
    console.log("Respuesta de red OK pero respuesta HTTP no OK");
  }
}

function handleResponsePDF(response) {
  if (response.ok) {
    response.blob().then(function (miBlob) {
      var fileURL = window.URL.createObjectURL(new Blob([miBlob]));
      var fileLink = document.createElement("a");
      fileLink.href = fileURL;
      fileLink.setAttribute(
        "download",
        new Date().toLocaleString().replace(/\D/g, "") + ".pdf"
      );
      document.body.appendChild(fileLink);
      fileLink.click();
    });
  } else {
    console.log("Respuesta de red OK pero respuesta HTTP no OK");
  }
}

function handleResponse(response) {
  return response.text().then((text) => {
    const data = text && JSON.parse(text);

    if (!response.ok) {
      const auth = useAuth();

      if ([401, 403].includes(response.status) && auth.token) {
        if (
          data &&
          (data.message === "Sesión cerrada en otro dispositivo" ||
            data.mensaje === "Sesión cerrada en otro dispositivo")
        ) {
          // Silenciar el error - solo hacer logout
          auth.handleRemoteLogout();

          // NO hacer reject - retornar objeto vacío para evitar errores en componentes
          return Promise.resolve({
            _logout: true,
            mensaje: "Sesión cerrada en otro dispositivo",
          });
        } else {
          auth.userLogout();

          return Promise.resolve({
            _logout: true,
            mensaje: "Sesión expirada",
          });
        }
      }

      if (
        data &&
        typeof data === "object" &&
        (data.mensaje || data.message || data.error_detallado)
      ) {
        return {
          status: response.status,
          mensaje: data.mensaje || data.message,
          message: data.message || data.mensaje,
          error_detallado: data.error_detallado,
          tipo_error: data.tipo_error,
          venta_anulada: data.venta_anulada,
          puede_reintentar: data.puede_reintentar,
          venta: data.venta,
          facturado: data.facturado,
          ...data,
        };
      }

      const error = {
        status: response.status,
        message:
          (data && data.message) ||
          (data && data.mensaje) ||
          response.statusText,
        data: data,
      };

      return Promise.reject(error);
    }

    return data;
  });
}